<div class="product-group">
    <div class="group-title">
        {{ translationKey | translate }}
    </div>
    <div class="group-items">
        <div class="group-item" *ngFor="let prod of products">
            <div class="item-description">
                {{ chooseTranslation(prod.translation) }} <br />
                {{ prod.material }}
            </div>
            <div class="item-quantity">{{ 'PRODUCT_GROUP.ITEM.QUANTITY' | translate }}: {{ prod.quantity }}</div>
        </div>
    </div>
</div>
